import { __ } from '@wordpress/i18n';
import { useContext, useCallback, useState, useEffect } from 'preact/hooks';

import { AppContext } from '../../context/AppContext';
import ProgramCheckbox from './ProgramCheckbox';
import { ProgramTerm } from '../../../../types';

import { CaretIcon } from '../icons/icons';

export default function ProgramFilter( { wpProgramTerms }: {wpProgramTerms: ProgramTerm[]} ) {
	const { filterContext } = useContext( AppContext );
	const [ filterState, dispatch ] = filterContext;
	const [ isOpen, setIsOpen ] = useState( false );

	const handleProgramChange = useCallback( ( value: string[] ) => {
		dispatch( { type: 'SET_PROGRAMS', payload: value } );
	}, [ dispatch ] );

	// Handle close on escape key press.
	useEffect( () => {
		const handleKeydown = ( event: KeyboardEvent ) => {
			if ( event.key === 'Escape' ) {
				setIsOpen( false );
			}
		};
		window.addEventListener( 'keydown', handleKeydown );

		return () => {
			window.removeEventListener( 'keydown', handleKeydown );
		};
	}, [] );

	// Close the dropdown when clicking outside of it.
	useEffect( () => {
		const handleClickOutside = ( event: MouseEvent ) => {
			const filterElement = document.querySelector( '.tcc-map__filter--programs' );
			if ( filterElement && ! filterElement.contains( event.target as Node ) ) {
				setIsOpen( false );
			}
		};
		window.addEventListener( 'click', handleClickOutside );
		
		return () => {
			window.removeEventListener( 'click', handleClickOutside );
		};
	}, [] );

	const hasProgramTerms = wpProgramTerms?.length > 0;

	return (
		<div className="tcc-map__filter tcc-map__filter--programs">
			<button
				className="tcc-map__filter-input"
				type="button"
				aria-expanded={ isOpen }
				aria-controls="tcc-map__filter-options--programs"
				onClick={ () => setIsOpen( ! isOpen ) }
				disabled={ ! hasProgramTerms }
			>
				<span className="tcc-map__filter-input-text">{ __( 'Programs', 'tcc-map' ) }</span>
				<span className="tcc-map__filter-input-icon">
					<CaretIcon />
				</span>
			</button>

			{ hasProgramTerms && (
				<div id="tcc-map__filter-options--programs" className={ `tcc-map__filter-options ${ isOpen ? 'visible' : '' }` }>
					<ul className={ 'tcc-map__checkbox-list' }>
						{ wpProgramTerms.map( ( item ) => (
							<ProgramCheckbox
								key={ item.term_id }
								item={ item }
								programs={ filterState.programs }
								handleProgramChange={ handleProgramChange }
							/>
						) ) }
					</ul>
				</div>
			) }
		</div>
	);
}
